// import { ref } from 'vue' // Not needed currently
import { useErrorHandling } from './useErrorHandling'
import { useLoadingState } from './useLoadingState'

export interface AsyncOperationConfig {
  showToast?: boolean
  toastMessage?: string
  logError?: boolean
  onSuccess?: (result: any) => void
  onError?: (error: any) => void
}

export function useAsyncOperation() {
  const { handleError, clearError, getError, hasError } = useErrorHandling()
  const { executeWithLoading, isLoading } = useLoadingState()

  const execute = async <T>(
    operationName: string,
    operation: () => Promise<T>,
    config: AsyncOperationConfig = {}
  ): Promise<T | null> => {
    try {
      clearError(operationName)
      
      const result = await executeWithLoading(operationName, operation, {
        onSuccess: config.onSuccess,
        onError: config.onError
      })
      
      return result
    } catch (error) {
      handleError(error, operationName, {
        showToast: config.showToast,
        toastMessage: config.toastMessage,
        logError: config.logError
      })
      return null
    }
  }

  return {
    execute,
    isLoading,
    getError,
    hasError,
    clearError
  }
}